namespace TabAurous.Membership {
    export interface SignUpRequest extends Serenity.ServiceRequest {
        DisplayName?: string;
        Email?: string;
        Password?: string;
        CompanyName?: string;
        PAN?: string;
        TaxId?: string;
        Mobile?: string;
    }
}
